import { render, staticRenderFns } from "./apimessagelist.vue?vue&type=template&id=7dbe8b96&"
import script from "./apimessagelist.vue?vue&type=script&lang=js&"
export * from "./apimessagelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports